<template>
    <button
        class="
            c-button-unstyled
            c-icon_button c-icon_button--light c-icon_button--size_small
            c-message_actions__button
        "
        type="button"
        v-bind="$attrs"
    >
        <i
            aria-hidden="true"
            v-if="icon"
            :class="['c-icon', `c-icon--${icon}`]"
            :type="icon"
        ></i>
    </button>
</template>
<script>
export default {
    props: ['icon'],
}
</script>
<style>
</style>